// @flow

import { combineReducers } from "redux";

import app from "@src/reducers/app";
import sideBar from "@src/reducers/sideBar";

export default combineReducers({
  app,
  sideBar
});



// WEBPACK FOOTER //
// ./src/reducers/index.js